export const lightColorTokens = {
    OV: {
        sys: {
            surfaceDim: '#d8dadb',
            surfaceBright: '#f8fafa',
            surfaceContainerLowest: '#ffffff',
            surfaceContainerLow: '#f2f4f4',
            surfaceContainer: '#eceeef',
            surfaceContainerHigh: '#e6e8e9',
            surfaceContainerHighest: '#e1e3e3',
            scrim: '#000000',
            outlineVariant: '#bec8ca',
            surfaceTint: '#00696c',
            shadow: '#000000',
            inversePrimary: '#4adade',
            inverseOnSurface: '#eff1f1',
            inverseSurface: '#2e3132',
            onSurfaceVariant: '#3f484a',
            surfaceVariant: '#dae4e6',
            onSurface: '#191c1d',
            surface: '#f8fafa',
            onBackground: '#191c1d',
            background: '#fafdfd',
            outline: '#6f797a',
            onErrorContainer: '#410002',
            errorContainer: '#ffdad6',
            onError: '#ffffff',
            error: '#bb171c',
            onTertiaryFixedVariant: '#004a7a',
            tertiaryFixedDim: '#9bcbff',
            onTertiaryFixed: '#001d34',
            tertiaryFixed: '#d0e4ff',
            onTertiaryContainer: '#001d34',
            tertiaryContainer: '#d0e4ff',
            onTertiary: '#ffffff',
            tertiary: '#0062a0',
            onSecondaryFixedVariant: '#6300bb',
            secondaryFixedDim: '#d8b9ff',
            onSecondaryFixed: '#290055',
            secondaryFixed: '#eedcff',
            onSecondaryContainer: '#290055',
            secondaryContainer: '#eedcff',
            onSecondary: '#ffffff',
            secondary: '#a259ff',
            onPrimaryFixedVariant: '#004f51',
            primaryFixedDim: '#4adade',
            onPrimaryFixed: '#002021',
            primaryFixed: '#6df6fa',
            onPrimaryContainer: '#002021',
            primaryContainer: '#6df6fa',
            onPrimary: '#ffffff',
            primary: '#00696c',
            success: '#00c853',
            successContainer: '#e0f5e8',
            onSuccessContainer: '#2e7d32',
            mentionText: '#3A516D',
            mentionTextBackground: '#F3F6FB',
            aiSuggestionsTextBackground: '#ACEEBB',
        },
        extended: {
            Essentials: {
                color: '#006c4d',
                onColor: '#ffffff',
                colorContainer: '#88f8c8',
                onColorContainer: '#002115',
            },
            Priority: {
                color: '#a33b3e',
                onColor: '#ffffff',
                colorContainer: '#ffdad8',
                onColorContainer: '#410007',
            },
            Proactive: {
                color: '#7231e2',
                onColor: '#ffffff',
                colorContainer: '#eaddff',
                onColorContainer: '#24005a',
            },
            Signature: {
                color: '#825500',
                onColor: '#ffffff',
                colorContainer: '#ffddb2',
                onColorContainer: '#291800',
            },
            SecurityOnly: {
                color: '#3b6b96',
                onColor: '#ffffff',
                colorContainer: '#d0e4f4',
                onColorContainer: '#001d36',
            },
        },
        entity: {
            conversation: '#00696c',
            site: '#7231e2',
            client: '#825500',
            project: '#0062a0',
            partner: '#825500',
        },
        custom: {
            Table: {
                hover: '#6060604D',
            },
            InternalNotes: {
                noteInputContainer: '#FFDE94',
                noteButton: '#8D6E63',
                noteButtonHover: '#7D6258',
                noteMessageContainer: '#FFF0C4',
                noteMessageBorder: '#FFDDB2',
            },
            Glass: {
                base: '#ffffff',
                tintPercent: 11,
                opacityPercent: 94,
            },
        },
    },
};
